(ns common.content-function.schemas
  (:require [clojure.set :refer [rename-keys]]))

(defn schemas-by-urn
  [schemas]
  (zipmap (map (comp :id :meta) schemas) schemas))

(defn find-urn
  [alias context]
  (->> alias
       ((zipmap (map :alias context) context))
       :schema))

(defn find-schema
  [urn schemas]
  ((schemas-by-urn schemas) urn))

(defn find-property
  "Return property matching `selector` in `schema`."
  [selector schema]
  (loop [path (rest selector)
         m (get-in schema [:data :out (first selector)])]
    (if (seq path)
      (let [[head & tail] path
            type (:type m)]
        (recur tail
               (case type
                 "list" (:items m)
                 "set" (:items m)
                 "object" (get-in m [:properties head])
                 (m head))))
      m)))

(defn find-values
  "List possible value options for property matching `selector` in `schema`.
   If `param` has additional options, concats them to the values from `schema`"
  ([selector schema param]
   (letfn [(f [x]
             (case (:type x)
               "set" (f (:items x))
               "option" (map #(rename-keys % {:id :value}) (:values x))
               "enum" (map #(hash-map :value % :label %) (:values x))
               []))]
     (let [schema-values (f (find-property selector schema))
           additional-values (get-in param [:options (first selector)])]
       (into (vec schema-values) additional-values)))))

(defn find-type
  "Return type vector for property matching `selector` in `schema`."
  [selector schema]
  (letfn [(f [schema]
            (case (:type schema)
              "object" ["object" (into {} (map (fn [[k v]]
                                                 [k (f v)])
                                               (:properties schema)))]
              "list" ["list" (f (:items schema))]
              "set" ["set" (f (:items schema))]
              (:type schema)))]
    (f (find-property selector schema))))
